module.exports = __webpack_public_path__ + "img/logo.586f55a4.png";